import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import { useState } from "react";

export function TagMenu({ allTags, convTags, tagColors, onToggle, onCreate, onDelete, onClose }) {
  const [newLabel, setNewLabel] = useState("");
  const [newColor, setNewColor] = useState("blue");
  return (
    <div
      data-testid="tag-menu"
      className="absolute right-0 top-full mt-1 bg-card border border-border/50 rounded-xl shadow-xl z-40 w-56 p-3 animate-in fade-in zoom-in-95 duration-150"
      onClick={e => e.stopPropagation()}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium">Tags</span>
        <button onClick={onClose} className="text-muted-foreground hover:text-foreground"><X className="w-3 h-3" /></button>
      </div>
      <div className="space-y-1 max-h-36 overflow-y-auto mb-2">
        {allTags.map(tag => {
          const c = tagColors.find(tc => tc.name === tag.color) || tagColors[0] || {};
          return (
            <div key={tag.id} className="flex items-center gap-2 group">
              <button
                data-testid={`tag-toggle-${tag.id}`}
                onClick={() => onToggle(tag.id)}
                className="flex-1 flex items-center gap-2 px-2 py-1 rounded-lg text-xs hover:bg-muted/50 transition-colors"
              >
                <span className="w-3 h-3 rounded-full flex-shrink-0" style={{ background: c.bg, border: `1.5px solid ${c.text}` }} />
                <span className="truncate">{tag.label}</span>
                {convTags.includes(tag.id) && <span className="ml-auto text-primary text-[10px]">&#10003;</span>}
              </button>
              <button
                onClick={() => onDelete(tag.id)}
                className="opacity-0 group-hover:opacity-100 p-0.5 text-muted-foreground hover:text-destructive transition-all"
              ><X className="w-3 h-3" /></button>
            </div>
          );
        })}
        {allTags.length === 0 && <p className="text-[10px] text-muted-foreground px-2 py-1">No tags yet</p>}
      </div>
      <div className="border-t border-border/30 pt-2 flex gap-1.5">
        <div className="flex gap-1 flex-shrink-0">
          {(tagColors || []).slice(0, 4).map(c => (
            <button key={c.name} onClick={() => setNewColor(c.name)}
              className={cn("w-5 h-5 rounded-full border-2 transition-all", newColor === c.name ? "border-foreground scale-110" : "border-transparent")}
              style={{ background: c.bg }} />
          ))}
        </div>
        <input
          data-testid="tag-create-input"
          value={newLabel}
          onChange={e => setNewLabel(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter" && newLabel.trim()) { onCreate(newLabel.trim(), newColor); setNewLabel(""); } }}
          placeholder="New tag..."
          className="flex-1 min-w-0 text-xs bg-muted/30 rounded-lg px-2 py-1 border border-border/30 focus:outline-none focus:border-primary/40"
        />
      </div>
    </div>
  );
}
